import { ROUTES_PATH } from "@/router";

export default function FallbackComponent() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <img
          src="/images/4ee90ee9-5220-48c2-8fc0-11a0de4664cd.png"
          alt="StartFLY Logo"
          className="h-20 mx-auto mb-10"
        />
        <p className="text-xl text-gray-600 mb-4">An error has occurred</p>
        <a
          href={ROUTES_PATH.LOGIN}
          className="text-blue-500 hover:text-blue-700 underline"
        >
          Return to login
        </a>
      </div>
    </div>
  );
}
